var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("add-language")))]),
      _c(
        "w-card-content",
        [
          _c("w-input-autocomplete", {
            attrs: {
              "empty-on-focus": "",
              open: _vm.input != "",
              label: _vm.$ct("language"),
              items: _vm.matchedLangs,
              fancy: "",
            },
            on: {
              "item-click": function ($event) {
                return _vm.langClicked($event.text)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (s) {
                  return [_c("p", [_vm._v(_vm._s(s.item.text))])]
                },
              },
            ]),
            model: {
              value: _vm.input,
              callback: function ($$v) {
                _vm.input = $$v
              },
              expression: "input",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.selectedLang, icon: "plus" },
              on: {
                click: function ($event) {
                  return _vm.addLanguage()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("add-language")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }